import { from } from "rxjs";
import "reflect-metadata";
import { APIMethod, APIResource } from "libs/utils/http/decorator/UrlDecorator";
import { apiMethodContext } from "libs/utils/http/builder/UrlConfig";
import { CloudConsoleClient } from "libs/utils/http/client/HttpClient";

import { ResourceType, AuthorizationRequest, AuthorizationResponse } from '../types';

@APIResource(CloudConsoleClient, "/authorizer")
class AuthorizerServiceImpl {
  @APIMethod("/authorize")
  public authorize(resources: AuthorizationRequest[], teamId: string) {
    return from(
      CloudConsoleClient.post<AuthorizationResponse[]>(
        apiMethodContext(arguments),
        resources,
        {
          params: {
            teamId
          }
        }
      ).then(response => response.data)
      .catch(error => {
        console.error('Authorization API error details:', error);
        throw error;
      })
    );
  }

  /**
   * Helper method to check if a specific action is allowed for a resource
   */
  public isActionAllowed(
    authorizations: AuthorizationResponse[],
    resourceType: ResourceType,
    resourceId: string,
    action: string
  ): boolean {
    const resourceAuth = authorizations.find(
      auth => auth.resourceType === resourceType && auth.resourceId === resourceId
    );
    return resourceAuth ? resourceAuth.allowedActions.includes(action) : false;
  }

  /**
   * Helper method to get all allowed actions for a resource
   */
  public getAllowedActions(
    authorizations: AuthorizationResponse[],
    resourceType: ResourceType,
    resourceId: string
  ): string[] {
    const resourceAuth = authorizations.find(
      auth => auth.resourceType === resourceType && auth.resourceId === resourceId
    );
    return resourceAuth ? resourceAuth.allowedActions : [];
  }
}

const AuthorizerService = new AuthorizerServiceImpl();

export default AuthorizerService;
